import { render, staticRenderFns } from "./RelatorioGerencialIntegradoList.vue?vue&type=template&id=024aef10&scoped=true"
import script from "./RelatorioGerencialIntegradoList.vue?vue&type=script&lang=js"
export * from "./RelatorioGerencialIntegradoList.vue?vue&type=script&lang=js"
import style0 from "./RelatorioGerencialIntegradoList.vue?vue&type=style&index=0&id=024aef10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024aef10",
  null
  
)

export default component.exports